<section class="py-12 p-8">
  <div class="mt-6 w-full max-w-6xl mx-auto">
    <header class="text-center">
      <h1 class="text-xl font-bold text-gray-900 sm:text-3xl my-8">
        My Orders
      </h1>
      <p *ngIf="userEmail" class="text-sm text-gray-600 mt-2">
        Showing orders for email: <strong>{{ userEmail }}</strong>
      </p>
    </header>

    <!-- Orders Display Section -->
    <div class="mt-8">
      <nz-spin [nzSpinning]="loading">
        <!-- No Results -->
        <div *ngIf="!loading && allOrders.length === 0" class="text-center py-12">
          <nz-empty 
            nzNotFoundImage="simple" 
            nzNotFoundContent="No orders found for this email address"
          ></nz-empty>
        </div>

        <!-- Orders List -->
        <div *ngIf="!loading && allOrders.length > 0" class="space-y-4">
          <div class="text-center mb-6">
            <h2 class="text-lg font-semibold text-gray-700">
              Found {{ totalItems }} order{{ totalItems !== 1 ? 's' : '' }}
            </h2>
          </div>

          <div *ngFor="let order of displayedOrders" class="mb-4">
            <nz-card [nzBordered]="true" class="shadow-sm hover:shadow-md transition-shadow">
              <div class="flex items-start justify-between mb-4">
                <div class="flex-1">
                  <div class="flex items-center gap-3 mb-2">
                    <h3 class="text-lg font-semibold text-gray-800">
                      Order #{{ order.orderNumber }}
                    </h3>
                    <nz-tag [nzColor]="getStatusColor(order.status)">
                      {{ order.status }}
                    </nz-tag>
                  </div>
                  
                  <div *ngIf="order.description" class="text-sm text-gray-700 mb-3">
                    {{ order.description }}
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                <div>
                  <p class="text-gray-500 mb-1">Order Date</p>
                  <p class="font-medium text-gray-900">{{ formatDate(order.orderDate) }}</p>
                </div>
                
                <div>
                  <p class="text-gray-500 mb-1">Total Amount</p>
                  <p class="font-medium text-gray-900">
                    {{ formatCurrency(order.amount + (order.processingFee || 0), order.currencyCode) }}
                  </p>
                  <p *ngIf="order.processingFee > 0" class="text-xs text-gray-500 mt-1">
                    (Includes {{ formatCurrency(order.processingFee, order.currencyCode) }} fee)
                  </p>
                </div>
                
                <div>
                  <p class="text-gray-500 mb-1">Payment Status</p>
                  <div class="flex items-center gap-2">
                    <nz-tag 
                      *ngIf="order.paymentTransaction"
                      [nzColor]="order.paymentTransaction.transactionStatus === 'SUCCESS' ? 'success' : 
                                order.paymentTransaction.transactionStatus === 'FAILED' ? 'error' : 'warning'"
                      class="!m-0"
                    >
                      {{ order.paymentTransaction.transactionStatus }}
                    </nz-tag>
                    <span *ngIf="!order.paymentTransaction" class="text-gray-600">
                      {{ order.status === 'COMPLETED' ? 'Paid' : 'Pending' }}
                    </span>
                  </div>
                </div>
              </div>
            </nz-card>
          </div>

          <!-- Pagination -->
          <div *ngIf="totalItems > 0" class="mt-8 text-center">
            <nz-pagination
              [nzPageIndex]="currentPage"
              [nzPageSize]="pageSize"
              [nzTotal]="totalItems"
              [nzShowSizeChanger]="true"
              [nzShowTotal]="totalTemplate"
              (nzPageIndexChange)="onPageChange($event)"
              (nzPageSizeChange)="onPageSizeChange($event)"
            ></nz-pagination>
            <ng-template #totalTemplate let-total let-range="range">
              Showing {{ range[0] }}-{{ range[1] }} of {{ total }} orders
            </ng-template>
          </div>
        </div>
      </nz-spin>
    </div>

    <!-- Featured Events Section -->
    <div *ngIf="featuredEvents.length > 0 || featuredEventsLoading" class="mt-12">
      <hypenation-tickets-events-list
        title="Featured Events"
        [totalItems]="featuredEventsTotalItems"
        [events]="featuredEvents"
        [loading]="featuredEventsLoading"
        [showFiltering]="false"
        loadMode="button"
        [hasMore]="featuredEventsHasMore"
        [loadingMore]="featuredEventsLoadingMore"
        (loadMore)="loadMoreFeatured()"
      ></hypenation-tickets-events-list>
    </div>
  </div>
</section>